import {Injectable, OnDestroy} from "@angular/core";
import {fromEvent} from "rxjs/observable/fromEvent";
import {Observable} from "rxjs/Observable";
import {Subscription} from "rxjs";
import {config} from "../../config/config";

@Injectable()
export class MediaQueryService implements OnDestroy {
    public resizeObservable$: Observable<Event>;
    resizeSubscription$: Subscription;

    public isMobile = false;
    public isPC = false;
    public isSmallerPC = false;
    public isSmallestPC = false;

    constructor() {
        const mobileQuery = window.matchMedia(`(max-width: ${config.phoneSizeWidth}px)`);
        const PCQuery = window.matchMedia(`(min-width: ${config.smallPCSizeWidth}px)`);
        const smallerPCQuery = window.matchMedia(`(min-width: ${config.smallestPCSizeWidth}px) and (max-width: ${config.smallPCSizeWidth}px)`);
        const smallestPCQuery = window.matchMedia(`(min-width: ${config.phoneSizeWidth}px) and (max-width: ${config.smallestPCSizeWidth}px)`);
        const _mobileQueryListener = () => {
            this.isMobile = mobileQuery.matches;
        };
        const PCQueryListener = () => {
            this.isPC = PCQuery.matches;
        };
        const smallerPCQueryListener = () => {
            this.isSmallerPC = smallerPCQuery.matches;
        };
        const smallestPCQueryListener = () => {
            this.isSmallestPC = smallestPCQuery.matches;
        };

        _mobileQueryListener();
        PCQueryListener();
        smallerPCQueryListener();
        smallestPCQueryListener();

        this.resizeObservable$ = fromEvent(window, 'resize');
        this.resizeSubscription$ = this.resizeObservable$.subscribe(evt => {
            console.log('resize in media obs');
            _mobileQueryListener();
            PCQueryListener();
            smallerPCQueryListener();
            smallestPCQueryListener();
            // mobileQuery.addListener(_mobileQueryListener);
            // PCQuery.addListener(PCQueryListener);
            // smallerPCQuery.addListener(smallerPCQueryListener);
            // smallestPCQuery.addListener(smallestPCQueryListener);
        });
    }

    ngOnDestroy(): void {
        this.resizeSubscription$.unsubscribe();
    }

    private log() {
        console.log('isMobile', this.isMobile);
        console.log('isPC', this.isPC);
        console.log('isSmallerPC', this.isSmallerPC);
        console.log('isSmallestPC', this.isSmallestPC);
    }
}


// import {ChangeDetectorRef, Injectable, OnDestroy} from '@angular/core';
// import {MediaMatcher} from "@angular/cdk/layout";
// import {config} from "../../config/config";
//
// @Injectable()
// export class MediaQueryService implements OnDestroy {
//     public mobileQuery: MediaQueryList;
//     public PCQuery: MediaQueryList;
//     public smallerPCQuery: MediaQueryList;
//     public smallestPCQuery: MediaQueryList;
//     public isMobile = false;
//     public isPC = false;
//     public isSmallerPC = false;
//     public isSmallestPC = false;
//
//     private readonly _mobileQueryListener: () => void;
//     private readonly _PCQueryListener: () => void;
//     private readonly _smallerPCQueryListener: () => void;
//     private readonly _smallestPCQueryListener: () => void;
//
//     // constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
//     constructor(media: MediaMatcher) {
//         this.mobileQuery = media.matchMedia(`(max-width: ${config.phoneSizeWidth}px)`);
//         this.PCQuery = media.matchMedia(`(min-width: ${config.smallPCSizeWidth})`);
//         this.smallerPCQuery = media.matchMedia(`(min-width: ${config.smallestPCSizeWidth}) and (max-width: ${config.smallPCSizeWidth})`);
//         this.smallestPCQuery = media.matchMedia(`(min-width: ${config.phoneSizeWidth}) and (max-width: ${config.smallestPCSizeWidth})`);
//
//         this.isMobile = this.mobileQuery.matches;
//         this.isPC = this.PCQuery.matches;
//         this.isSmallerPC = this.smallerPCQuery.matches;
//         this.isSmallestPC = this.smallestPCQuery.matches;
//
//         this._mobileQueryListener = () => {
//             // changeDetectorRef.detectChanges();
//             this.isMobile = this.mobileQuery.matches;
//             this.log();
//         }
//         this._PCQueryListener = () => {
//             this.isPC = this.PCQuery.matches;
//             this.log();
//         }
//         this._smallerPCQueryListener = () => {
//             this.isSmallerPC = this.smallerPCQuery.matches;
//             this.log();
//         }
//         this._smallestPCQueryListener = () => {
//             this.isSmallestPC = this.smallestPCQuery.matches;
//             this.log();
//         }
//         this.mobileQuery.addEventListener('change', this._mobileQueryListener);
//         this.PCQuery.addEventListener('change', this._PCQueryListener);
//         this.smallerPCQuery.addEventListener('change', this._smallerPCQueryListener);
//         this.smallestPCQuery.addEventListener('change', this._smallestPCQueryListener);
//
//
//     }
//
//     ngOnDestroy(): void {
//         this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
//         this.PCQuery.removeEventListener('change', this._PCQueryListener);
//         this.smallerPCQuery.removeEventListener('change', this._smallerPCQueryListener);
//         this.smallestPCQuery.removeEventListener('change', this._smallestPCQueryListener);
//     }
//
//     private log() {
//         console.log('isMobile', this.isMobile);
//         console.log('isPC', this.isPC);
//         console.log('isSmallerPC', this.isSmallerPC);
//         console.log('isSmallestPC', this.isSmallestPC);
//     }
// }



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/services/media.query.service.ts